import * as React from 'react';
import { connect } from 'react-redux';
import { fetchShipPrices } from '../../actions/shipOverviewAction';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import { IPageDataReducer } from '../../reducers/pageData';
import { IShipOverview } from '../../reducers/shipOverview';
import { CompanySection } from './components/CompanySection';
import { TrackComponent } from '../../components/TrackComponent';
import { FurtherInfo } from '../../components/FurtherInfo/FurtherInfo';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import { shipList } from '../../components/Recommendation/shipList';
import { eventTracker, ITrackingData } from '../../helpers/EventTracker/EventTracker';
import { __ } from '../../helpers/TranslationService';
import { LoadingIndicator, LoadingIndicatorInline } from '../../components/LoadingIndicator';
import { loadMore, newSearch, newSortSearch } from '../../actions/shipOverviewAction';
import { ShipSearchBar } from '../../components/ShipSearchBar/ShipSearchBar';
import { ShipSortBar } from '../../components/ShipSortBar/ShipSortBar';
import { Button } from '../../components/Button/Button';
import { OverviewPageHeader } from '../../components/OverviewPageHeader/OverviewPageHeader';
import { IState } from '../../reducers';

interface StateProps {
    shipOverview: IShipOverview;
    pageData: IPageDataReducer;
    isLoaded: boolean;
}

interface DispatchProps {
    fetchShipPrices: Function;
    newSortString: Function;
    sortShipListByRelevance: Function;
    newSearch: Function;
    addMore: Function;
}

type Props = StateProps & DispatchProps;

const showMoreTracking: ITrackingData = {
    category: 'ship-overview',
    action: 'ship show more',
    label: 'click',
};
class ShipOverviewPageClass extends React.Component<Props, any> {
    refs: {
        shipFilters: any;
    };

    getCompanies = () => {
        const companies = this.props.shipOverview.companies.map((company) => {
            return (
                <CompanySection
                    key={company.title}
                    company={company}
                    pageData={this.props.pageData}
                    fetchShipPrices={this.props.fetchShipPrices}
                />
            );
        });
        return companies;
    };

    render() {
        const {
            content,
            breadcrumbs,
            ships,
            facets,
            queryParams,
            numResults,
        } = this.props.shipOverview;

        const { deviceType } = this.props.pageData;

        const isDesktop = deviceType === 'desktop';

        const shipListProps = {
            deviceType,
            ships: ships.map((item) => {
                item.teaserImage = item.teaserImageUrl;
                return item;
            }),
            logo: null,
        };

        const getValuesForNewSearch = ({ isLoadMore } = { isLoadMore: false }) => {
            const { shipFilters } = this.refs;
            const filters = shipFilters.getFilters();
            const payload = {
                shipCategory: filters.shipCategory,
                shipType: filters.shipType,
                ship: filters.ship,
                company: filters.company,
                countryCode: queryParams.countryCode,
                offset: isLoadMore ? ships.length : 0,
            };

            return payload;
        };

        const onLoadMoreResults = () => {
            const valuesOfNewSearch = getValuesForNewSearch({ isLoadMore: true });
            this.props.addMore(valuesOfNewSearch);
            eventTracker.track(showMoreTracking);
        };
        const onNewSearchRequest = (newCriteria) => {
            const valuesOfNewSearch = getValuesForNewSearch();
            this.props.newSearch(Object.assign({}, valuesOfNewSearch, newCriteria));
        };
        const onNewSortRequest = (newSortCriteria) => {
            const valuesOfNewSearch = getValuesForNewSearch();
            this.props.newSortString(
                Object.assign({}, valuesOfNewSearch, newSortCriteria, {
                    limit: ships.length || undefined,
                }),
            );
        };

        const showLabelExistMoreShips = () => {
            if (ships.length < numResults && this.props.pageData.isLoaded) {
                return (
                    <Button size="small" color="secondary" onClick={onLoadMoreResults}>
                        {__('load more', 'dreamlines')}
                    </Button>
                );
            } else {
                if (ships.length === numResults) return null;

                return (
                    <>
                        <LoadingIndicatorInline />
                    </>
                );
            }
        };

        const MoreInfo = () => {
            if (!content.seoText) return null;

            const InfoSection = TrackComponent(CollapsibleText, {
                category: 'mobile-shipOverviewPage',
                action: 'navigation',
                label: 'more info',
            });

            return !isDesktop ? (
                <InfoSection text={content.seoText} defaultExpanded={false} />
            ) : (
                <FurtherInfo defaultExpanded={false} description={content.seoText} />
            );
        };

        const { bannerHeadline, bannerSubline } = content;
        return (
            <div className="ship-overview-page">
                <div className="ship-overview-page--container">
                    {isDesktop && (
                        <>
                            <Breadcrumbs className="onlyTabletUp" breadcrumbs={breadcrumbs} />
                            <OverviewPageHeader title={bannerHeadline} subTitle={bannerSubline} />
                            <ShipSearchBar
                                title={__('Find your Ship', 'dreamlines')}
                                shipCategories={__('Shipcategory', 'dreamlines')}
                                shipType={__('Shiptype', 'dreamlines')}
                                shipCruiselines={__('Company', 'dreamlines')}
                                ref="shipFilters"
                                facets={facets}
                                newSearch={onNewSearchRequest}
                                queryParams={queryParams}
                            />

                            <ShipSortBar
                                options={[
                                    { text: __('Alphabetical', 'dreamlines'), value: 'name' },
                                    {
                                        text: __('Shipcategories', 'dreamlines'),
                                        value: 'category_desc',
                                    },
                                ]}
                                label={__('Sorted by:', 'dreamlines')}
                                ref="sortString"
                                newSortString={onNewSortRequest}
                            />
                        </>
                    )}
                    {!isDesktop ? (
                        <>
                            <OverviewPageHeader title={bannerHeadline} subTitle={bannerSubline} />
                            {this.getCompanies()}
                        </>
                    ) : (
                        <>
                            {!this.props.isLoaded && <LoadingIndicator />}

                            {this.props.isLoaded && (
                                <>
                                    <RecommendationSection
                                        key={`Recommendation ShipOverviewPage`}
                                        data={shipList(shipListProps)}
                                        collapsibleComponent={true}
                                    />
                                    <div className="loadmore">{showLabelExistMoreShips()}</div>
                                </>
                            )}
                        </>
                    )}
                    <MoreInfo />
                    {!isDesktop && <Breadcrumbs className="onlyMobile" breadcrumbs={breadcrumbs} />}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IState) => ({
    shipOverview: state.shipOverview,
    pageData: state.pageData,
    isLoaded: state.shipOverview.isLoaded,
});

const mapDispatchToProps = {
    fetchShipPrices,
    addMore: loadMore,
    newSortString: newSortSearch,
    sortShipListByRelevance: newSearch,
    newSearch,
};

export const ShipOverviewPage = connect<StateProps, DispatchProps, any>(
    mapStateToProps,
    mapDispatchToProps,
)(ShipOverviewPageClass);
export default ShipOverviewPage;
